/* =====================================================
   DARUSSALAM CART DRAWER  v2  - assets/darussalam-cart.js
   ===================================================== */

(function () {
  'use strict';

  const drawerEl = () => document.querySelector('cart-drawer.dsc-drawer');

  /* ?? 1. FORCE-OPEN: hijack any link to /cart ?????????
     Bug fix: theme nav was navigating to /cart instead of
     opening the drawer. We capture every cart link click
     and call the drawer's open() method.
  ??????????????????????????????????????????????????????? */
  function bindCartTriggers() {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest(
        'a[href$="/cart"], a[href*="/cart?"], ' +
        'a[href="#cart"], [data-cart-drawer-toggle], ' +
        '.header__icon--cart, #cart-icon-bubble, .cart-link, ' +
        'a[aria-label*="cart" i], a[aria-label*="basket" i]'
      );
      if (!trigger) return;
      // Allow if user explicitly wants to navigate (cmd/ctrl-click, middle click)
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

      const dr = drawerEl();
      if (!dr) return;

      e.preventDefault();
      e.stopPropagation();
      openDrawer(dr);
    }, true); // capture phase: beat theme handlers
  }

  function openDrawer(dr) {
    if (typeof dr.open === 'function') {
      dr.open();
    } else {
      dr.setAttribute('open', '');
      dr.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function closeDrawer(dr) {
    if (typeof dr.close === 'function') {
      dr.close();
    } else {
      dr.removeAttribute('open');
      dr.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }


  /* ?? 3. REMOVE ANIMATION ??????????????????????????? */
  function bindRemoveAnimations() {
    document.querySelectorAll('.dsc-item__remove').forEach(btn => {
      if (btn.dataset.dsBound === '1') return;
      btn.dataset.dsBound = '1';
      btn.addEventListener('click', function () {
        const li = btn.closest('.dsc-item');
        if (li) li.classList.add('is-removing');
      }, { capture: true });
    });
  }

  /* ?? 4. PAIR-WITH CAROUSEL: scroll snap + arrows ??? */
  function bindPairCarousel() {
    const list = document.querySelector('[data-pair-list]');
    const prev = document.querySelector('[data-pair-prev]');
    const next = document.querySelector('[data-pair-next]');
    if (!list || list.dataset.dsBound === '1') return;
    list.dataset.dsBound = '1';

    function getStep() {
      const item = list.querySelector('.dsc-pair__item');
      return item ? item.getBoundingClientRect().width + 0 : list.clientWidth;
    }

    function updateNavState() {
      if (!prev || !next) return;
      prev.disabled = list.scrollLeft <= 4;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    }

    if (prev) {
      prev.addEventListener('click', () => {
        list.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        list.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }
    list.addEventListener('scroll', updateNavState, { passive: true });
    updateNavState();

    // Drag-to-scroll
    let isDown = false, startX = 0, scrollLeft = 0;
    list.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
      list.style.cursor = 'grabbing';
    });
    ['mouseleave', 'mouseup'].forEach(ev =>
      list.addEventListener(ev, () => {
        isDown = false;
        list.style.cursor = '';
      })
    );
    list.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - list.offsetLeft;
      list.scrollLeft = scrollLeft - (x - startX) * 1.6;
    });
  }

  /* ?? 5. PAIR-WITH AJAX ADD ??????????????????????? */
  function bindPairAdd() {
    document.querySelectorAll('[data-pair-form]').forEach(form => {
      if (form.dataset.dsBound === '1') return;
      form.dataset.dsBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const btn = form.querySelector('.dsc-pair__add');
        if (!btn || btn.disabled) return;

        const id = form.querySelector('input[name="id"]').value;
        const qty = form.querySelector('input[name="quantity"]').value || 1;

        btn.classList.add('is-loading');
        btn.disabled = true;

        const body = JSON.stringify({
          items: [{ id: parseInt(id, 10), quantity: parseInt(qty, 10) }],
          sections: getSectionsToBundle()
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: body
        })
        .then(r => r.json())
        .then(data => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');

          // Refresh the drawer using the existing CartDrawer custom element
          refreshDrawer(data);

          setTimeout(() => {
            btn.classList.remove('is-done');
            btn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });
  }

  function getSectionsToBundle() {
    const dr = drawerEl();
    if (dr && typeof dr.getSectionsToRender === 'function') {
      return dr.getSectionsToRender().map(s => s.id);
    }
    return ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble-sticky'];
  }

  function refreshDrawer(addData, opts) {
    const dr = drawerEl();
    if (!dr) return;
    const silent = !!(opts && opts.silent);

    // If theme exposes renderContents, use it; otherwise fall back to fetching the drawer section
    if (typeof dr.renderContents === 'function' && addData && addData.sections) {
      try {
        dr.renderContents({
          ...addData,
          getSectionInnerHTML: function (html, selector) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const target = tmp.querySelector(selector || '.shopify-section');
            return target ? target.innerHTML : html;
          }
        });
        return;
      } catch (e) { /* fall through */ }
    }

    // Fallback: fetch the drawer HTML and swap inner content only (avoid destroying the custom element)
    // no-store: a cached response here would overwrite a just-toggled
    // prepay checkbox with stale (pre-toggle) markup.
    fetch(window.location.pathname + '?sections=cart-drawer', { cache: 'no-store' })
      .then(r => r.json())
      .then(payload => {
        const html = payload['cart-drawer'];
        if (!html) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const freshInner = tmp.querySelector('#CartDrawer');
        const currentInner = dr.querySelector('#CartDrawer');
        if (!freshInner || !currentInner) return;
        currentInner.innerHTML = freshInner.innerHTML;
        dr.classList.remove('is-empty');
        rebindAll();
        if (!silent) openDrawer(dr);
      })
      .catch(() => {});
  }

  /* ── 5b. COMPLETE YOUR LIBRARY: checkboxes + bulk add ── */
  function updateCylButton() {
    const section = document.querySelector('[data-dsc-cyl]');
    if (!section) return;
    const btn = section.querySelector('[data-cyl-add]');
    if (!btn) return;
    const checked = section.querySelectorAll('[data-cyl-check]:checked');
    btn.disabled = checked.length === 0;
  }

  function bindCylCheckboxes() {
    document.querySelectorAll('[data-cyl-check]').forEach(cb => {
      if (cb.dataset.dsBound === '1') return;
      cb.dataset.dsBound = '1';
      // stopPropagation: the theme's native cart-quantity listener treats ANY
      // change event inside the cart form as a quantity update. Without this,
      // checking a box (value defaults to "on") fires a bogus /cart/change
      // request and shows "There was an error while updating your cart."
      cb.addEventListener('change', function (e) {
        e.stopPropagation();
        updateCylButton();
      });
    });
    updateCylButton();
  }

  function bindCylAdd() {
    const btn = document.querySelector('[data-cyl-add]');
    if (!btn || btn.dataset.dsBound === '1') return;
    btn.dataset.dsBound = '1';

    btn.addEventListener('click', function () {
      const checked = document.querySelectorAll('[data-cyl-check]:checked');
      if (!checked.length || btn.disabled) return;

      const items = Array.from(checked).map(cb => ({
        id: parseInt(cb.dataset.variantId, 10),
        quantity: 1
      }));

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items, sections: getSectionsToBundle() })
      })
      .then(r => r.json())
      .then(data => {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        refreshDrawer(data);
        setTimeout(() => { btn.classList.remove('is-done'); }, 2000);
      })
      .catch(() => {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
    });
  }

  /* ── 5c. COMPLETE YOUR LIBRARY: single-suggestion 1-tap add ── */
  function bindCylSingleAdd() {
    document.querySelectorAll('[data-cyl-single-add]').forEach(btn => {
      if (btn.dataset.dsBound === '1') return;
      btn.dataset.dsBound = '1';

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        const id = btn.dataset.variantId;

        btn.classList.add('is-loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(id, 10), quantity: 1 }],
            sections: getSectionsToBundle()
          })
        })
        .then(r => r.json())
        .then(data => {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          refreshDrawer(data);
          setTimeout(() => {
            btn.classList.remove('is-done');
            btn.disabled = false;
          }, 2000);
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    });
  }


  /* ── 5d. PAY ONLINE & SAVE TOGGLE (PK only) ── */
  function persistPrepay(value) {
    // keepalive: survives an immediate navigation (e.g. Checkout button)
    // right after toggling from inside the drawer.
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { prepay_discount: value ? 'true' : 'false' } }),
      keepalive: true,
      cache: 'no-store'
    });
  }

  function bindPrepayToggle() {
    document.querySelectorAll('.dsc-cart-drawer [data-ds-prepay-toggle]').forEach(cb => {
      if (cb.dataset.dsBound === '1') return;
      cb.dataset.dsBound = '1';
      cb.addEventListener('change', function (e) {
        e.stopPropagation();
        // Dispatch only after the server has the new attribute, so the
        // silent refresh this triggers doesn't fetch a stale discount state.
        persistPrepay(cb.checked)
          .catch(() => {})
          .then(() => {
            document.dispatchEvent(new CustomEvent('ds:prepay-changed', { detail: { value: cb.checked } }));
          });
      });
    });
  }

  // Fires whether the PDP toggle or the drawer toggle changed — keeps every
  // instance of the switch in sync and refreshes the drawer's totals (the
  // discount line only exists in the server-rendered cart object) without
  // popping the drawer open on a PDP-triggered change.
  if (!window._dsPrepaySyncBound) {
    window._dsPrepaySyncBound = true;
    document.addEventListener('ds:prepay-changed', function (e) {
      document.querySelectorAll('[data-ds-prepay-toggle]').forEach(cb => {
        cb.checked = !!e.detail.value;
      });
      refreshDrawer(null, { silent: true });
    });
  }

  /* ?? 6. RE-BIND on cart updates ????????????????????? */
  function rebindAll() {
    bindRemoveAnimations();
    bindPairCarousel();
    bindPairAdd();
    bindCylCheckboxes();
    bindCylAdd();
    bindCylSingleAdd();
    bindPrepayToggle();
  }

  function observeCart() {
    const target = document.querySelector('.dsc-cart-drawer');
    if (!target) return;
    const ob = new MutationObserver(() => {
      clearTimeout(ob._t);
      ob._t = setTimeout(rebindAll, 80);
    });
    ob.observe(target, { childList: true, subtree: true });
  }

  /* ?? 7. INIT ???????????????????????????????????????? */
  function init() {
    bindCartTriggers();
    rebindAll();
    observeCart();

    if (window.PUB_SUB_EVENTS && window.subscribe) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, rebindAll);
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── BUNDLE BOOKS ACCORDION ──────────────────────── */
(function () {
  'use strict';

  function bindBundleToggles(root) {
    var toggles = (root || document).querySelectorAll('[data-dsc-bn-toggle]');
    toggles.forEach(function (btn) {
      if (btn._bnBound) return;
      btn._bnBound = true;
      btn.addEventListener('click', function () {
        var list = btn.closest('.dsc-bundle-books').querySelector('[data-dsc-bn-list]');
        if (!list) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (open) {
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        } else {
          list.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function autoExpandFirst(root) {
    var first = (root || document).querySelector('.dsc-item--bundle [data-dsc-bn-toggle]');
    if (first && first.getAttribute('aria-expanded') !== 'true') {
      first.click();
    }
  }

  function initBundleAccordions() {
    bindBundleToggles(document);
    autoExpandFirst(document);
  }

  var cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && (node.matches('.dsc-item--bundle') || node.querySelector('.dsc-item--bundle'))) {
          bindBundleToggles(node);
          autoExpandFirst(node);
        }
      });
    });
  });

  function observeCartForBundles() {
    var itemsEl = document.getElementById('CartDrawer-CartItems');
    if (itemsEl) {
      cartObserver.observe(itemsEl, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBundleAccordions(); observeCartForBundles(); });
  } else {
    initBundleAccordions();
    observeCartForBundles();
  }
})();

/* ── BUNDLE ITEM ENHANCEMENT (JS-only, no Liquid changes) ── */
(function () {
  'use strict';

  function enhanceBundleItems(root) {
    var items = (root || document).querySelectorAll('.dsc-item[data-bundle-books]');
    items.forEach(function (li) {
      if (li.dataset.bundleEnhanced) return;
      li.dataset.bundleEnhanced = '1';

      var name   = li.dataset.bundleName   || 'Bundle Offer';
      var books  = li.dataset.bundleBooks  || '';
      var saving = li.dataset.bundleSaving || '';
      var bookList = books.split('|').filter(Boolean);

      li.style.border        = '1.5px solid #C49A2E';
      li.style.borderRadius  = '14px';
      li.style.background    = '#1E1810';
      li.style.overflow      = 'hidden';

      var banner = document.createElement('div');
      banner.className = 'dsc-bundle-banner';
      banner.style.cssText = 'grid-column:1/-1;display:flex;align-items:center;justify-content:space-between;gap:10px;background:linear-gradient(90deg,#0a1610 0%,#162618 100%);padding:8px 14px;margin:-1px -1px 0;border-radius:12px 12px 0 0;';
      banner.innerHTML =
        '<div style="display:flex;align-items:center;gap:7px;">' +
          '<svg width="13" height="13" viewBox="0 0 13 13" fill="none"><rect x="1" y="4" width="11" height="8" rx="1" stroke="#C49A2E" stroke-width="1.2"/><path d="M4.5 4V3a2 2 0 0 1 4 0v1" stroke="#C49A2E" stroke-width="1.2"/></svg>' +
          '<span style="font-size:9.5px;font-weight:800;letter-spacing:.2em;text-transform:uppercase;color:#C49A2E;">BUNDLE OFFER</span>' +
          '<span style="font-size:11px;font-weight:600;color:rgba(255,255,255,.65);">' + name + '</span>' +
        '</div>' +
        (saving ? '<span style="font-size:9.5px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;background:#1a7a3c;color:#fff;padding:3px 10px;border-radius:20px;white-space:nowrap;">' + saving + '</span>' : '');
      li.insertBefore(banner, li.firstChild);

      if (bookList.length > 0) {
        var titleEl = li.querySelector('.dsc-item__title');
        if (titleEl) {
          var wrap = document.createElement('div');
          wrap.style.cssText = 'margin:6px 0 2px;';
          var toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.setAttribute('aria-expanded', 'true');
          toggle.style.cssText = 'display:flex;align-items:center;gap:5px;font-size:11.5px;font-weight:600;color:#C49A2E;background:none;border:none;padding:0;cursor:pointer;';
          toggle.innerHTML = '<svg style="transition:transform .25s" width="11" height="7" viewBox="0 0 11 7" fill="none"><path d="M1 1.5l4.5 4 4.5-4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' + bookList.length + ' books included';

          var list = document.createElement('ul');
          list.style.cssText = 'list-style:none;margin:6px 0 0;padding:0;display:flex;flex-direction:column;gap:4px;';
          bookList.forEach(function (b) {
            var li2 = document.createElement('li');
            li2.style.cssText = 'font-size:11px;color:rgba(255,255,255,.65);display:flex;align-items:baseline;gap:6px;';
            li2.innerHTML = '<span style="width:4px;height:4px;border-radius:50%;background:#C49A2E;flex-shrink:0;display:inline-block;margin-top:2px;"></span>' + b;
            list.appendChild(li2);
          });

          toggle.addEventListener('click', function () {
            var open = toggle.getAttribute('aria-expanded') === 'true';
            list.style.display = open ? 'none' : 'flex';
            toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
            toggle.querySelector('svg').style.transform = open ? 'rotate(-90deg)' : '';
          });

          wrap.appendChild(toggle);
          wrap.appendChild(list);
          titleEl.insertAdjacentElement('afterend', wrap);
        }
      }
    });
  }

  var cartObs = new MutationObserver(function () {
    enhanceBundleItems(document.querySelector('#CartDrawer'));
  });
  function observeBundleEnhance() {
    var cd = document.querySelector('#CartDrawer');
    if (cd) cartObs.observe(cd, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      enhanceBundleItems(); observeBundleEnhance();
    });
  } else {
    enhanceBundleItems(); observeBundleEnhance();
  }
})();

